import PermissionGuard from 'components/Global/PermissionGuard';
import EarningComponent from 'components/Settings/PayrollSettings/Earning';

export const Earning = () => {
	return (
		<PermissionGuard permission="Allow_Earnings_Code">
			<EarningComponent />
		</PermissionGuard>
	);
};
